module.exports = __webpack_public_path__ + "media/assets/images/icons/attachments-icon1-ee1ce8ec29f87ba6ef900a40de171510.svg";